import React from 'react';
import QuizHeader from "./QuizHeader/QuizHeader";
import QuizSidebar from "./QuizSidebar/QuizSidebar";
import { useSelector } from "react-redux";

/**
 * Header and side bar of quiz module.
 * @param props
 * @returns {*}
 * @constructor
 */
const HeaderSidebar = props => {
    const {
        viewMode,
        drawerToggle,
        isLoading,
        changeSectionActive,
        quizMode,
        toggleDrawerHandler,
        setTimeTaken,
        submitQuiz,
        toggleInstructionBox,
        selectPaletteQuestion,
        showInstructionBox,
        isFullscreen,
        handleFullScreen,
        pauseQuiz,
        handleQuizPauseChange
    } = props;
    const activeQuestionIndex = useSelector((state) => state.activeQuestionIndex);
    const quiz = useSelector((state) => state.quiz);
    const user = useSelector((state) => state.user);
    const { name, duration, locales, result, timeTaken } = quiz;
    let localeName = name;
    if (locales && locales[user.language] && locales[user.language].name) {
        localeName = locales[user.language].name;
    }

    return (
        <React.Fragment>
            <QuizHeader usedTime={timeTaken}
                        number={activeQuestionIndex + 1}
                        drawerToggle={drawerToggle}
                        toggleDrawerHandler={toggleDrawerHandler}
                        setTimeTaken={setTimeTaken}
                        isLoading={isLoading}
                        viewMode={viewMode}
                        mode={quizMode}
                        submitQuiz={submitQuiz}
                        duration={duration}
                        name={localeName}
                        quizPage={true}
                        language={user.language || 'en'}
                        pauseQuiz={pauseQuiz}
                        handleQuizPauseChange={handleQuizPauseChange}
                        isFullscreen={isFullscreen}
                        handleFullScreen={handleFullScreen}
                        drawerToggle={drawerToggle}/>

            <QuizSidebar viewMode={viewMode}
                         drawerToggle={drawerToggle}
                         handler={toggleDrawerHandler}
                         duration={duration}
                         result={result}
                         mode={quizMode}
                         submitQuiz={submitQuiz}
                         isLoading={isLoading}
                         toggleInstructionBox={toggleInstructionBox}
                         selectPaletteQuestion={selectPaletteQuestion}
                         timeTaken={timeTaken}
                         activeQuestionIndex={activeQuestionIndex}
                         changeSectionActive={changeSectionActive}

            />
        </React.Fragment>
    );
};

export default HeaderSidebar;
